
// src/reducers/right-sidebar-reducer.js

import {
  OPEN_RIGHT_SIDE_PAGE,
  CLOSE_RIGHT_SIDE_PAGE,
} from '../actions/right-sidebar'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'
import isArray from 'lodash/isArray'
import isEqual from 'lodash/isEqual'
import concat from 'lodash/concat'
import isObject from 'lodash/isObject'
import merge from 'lodash/merge'


const initialState = {
  name: undefined,
  params: undefined,
  lastState: undefined,
}

export default function rightSidebarReducer(state = initialState, action = {}) {
  switch(action.type) {
  case OPEN_RIGHT_SIDE_PAGE:
    var params = cloneDeep(action.params)
    delete params.append
    action.params.append && each(action.params.append, (value, key)=> {
      params[key] = value
      if (state.params && state.params[key] && isArray(state.params[key])) {
        params[key] = concat(state.params[key], value)
      }
      else if (state.params && state.params[key] && isObject(state.params[key])) {
        params[key] = merge(state.params[key], value)
      }
    })
		if (state.name == action.name && isEqual(state.params, params) && !action.push)
			return state
    return Object.assign({}, state, {
      name: action.name,
      params: params,
      lastState: action.push && { name: state.name, params: state.params } || undefined
    })

  case CLOSE_RIGHT_SIDE_PAGE:
    if (state.lastState && !action.forced)
      return Object.assign({}, state, {
        name: state.lastState.name,
        params: state.lastState.params,
        lastState: undefined,
      })
    else
      return Object.assign({}, state, {
        name: undefined,
        params: undefined,
        lastState: undefined,
      })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/right-sidebar-reducer.js